import * as React from 'react';
import { ButtonGroup, Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import 'components/desktop/_general/UserAvatar/UserAvatar.scss';
import PERMISSIONS from 'enums/permissions';
import { logout } from 'functions/tokenFunctions';
import { RootState } from 'reducers/rootReducer';

import NavigationLanguageSwitch from '../NavigationLanguage/NavigationLanguageSwitch';

interface IProps {
	userName: string;
	path: string;
}

const UserAvatar: React.FC<IProps> = (props: IProps) => {
	const { t } = useTranslation();
	const reduxAllowedUiLanguages: string[] = useSelector(
		(state: RootState) => state.allowedUiLanguages
	);

	const getPath = (): string => {
		if (props.path) {
			return props.path;
		} else {
			return '/img/navigation/default_user_icon.jpg';
		}
	};

	return (
		<>
				<Dropdown as={ButtonGroup} autoClose={false}>
					<div
						className="nav-link d-flex align-items-center"
						id="navbarUserProfile"
						role="button"
					>
						<img alt="User Avatar" className="navigation-user-img" src={getPath()} />
						<span style={{ marginLeft: '0.4rem', marginRight: '0.4rem' }}>
							{/* {props.userName?.split(' ').pop()} */}
							{props.userName?.split(' ')[0]}
						</span>
					</div>
					<Dropdown.Toggle split id="dropdown-split-basic" />
					<Dropdown.Menu>
						<Dropdown.Item>
							<NavLink to="/user/settings" className="dropdown-item">
								{t('_general:SETTINGS')}
							</NavLink>
						</Dropdown.Item>
						<Dropdown.Item>
							<NavLink to="/systemInfo" className="dropdown-item">
								{t('_general:SYSTEM_INFO')}
							</NavLink>
						</Dropdown.Item>
						<Dropdown.Item>
							<RenderIf condition={reduxAllowedUiLanguages.length > 1}>
								<NavigationLanguageSwitch />
							</RenderIf>
						</Dropdown.Item>
						<Dropdown.Item className='text-danger' onClick={logout}>{t('header:LOGOUT')}</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>
		</>
	);
};

export default UserAvatar;
